// import contactApi from './dev';  // dev
import contactApi from './prod'; // prod

export default contactApi;
